import defaultKeyWords from '@/view/d2/key-words'

const state = {
  keyWords: []
}

const mutations = {
  SET_KEYWORDS: (state, keyWords) => {
    state.keyWords = keyWords
  }
}

const actions = {
  changeKeyWords({ commit }, data) {
    commit('SET_KEYWORDS', data)
  },
  initKeyWords({ commit }) {
    commit('SET_KEYWORDS', defaultKeyWords)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
